import { render, staticRenderFns } from "./ShowAnnouncementList.vue?vue&type=template&id=2dd57d6e&scoped=true"
import script from "./ShowAnnouncementList.vue?vue&type=script&lang=js"
export * from "./ShowAnnouncementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd57d6e",
  null
  
)

export default component.exports